var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import * as CatizColors from '../../Catiz3/CMSTouchPanel/colors';
import WindowConfigContext from '../../context/window-config-context';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
var RoleTable = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n"], ["\n  display: grid;\n"])));
export var flattenRoleArrForDisplay = function (items, levelDict, level) {
    if (level === void 0) { level = 1; }
    var resultArr = [];
    if (!items) {
        return [];
    }
    items.forEach(function (item, index) {
        var _a, _b;
        resultArr.push(__assign({ level: level, isSelected: item.isSelected, levelDict: __assign(__assign({}, levelDict), (_a = {}, _a[level] = false, _a)), lastChild: items.length - 1 === index }, ['Overlays', 'eye', 'Slave'].reduce(function (acc, col) {
            var _a;
            return __assign(__assign({}, acc), (_a = {}, _a[col] = item[col], _a));
        }, {})));
        if (item.children) {
            resultArr = resultArr.concat(flattenRoleArrForDisplay(typeof item.children === 'string'
                ? JSON.parse(item.children)
                : item.children, __assign(__assign({}, levelDict), (_b = {}, _b[level] = items.length - 1 === index, _b)), level + 1));
        }
    });
    return resultArr;
};
var Row = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  grid-template-columns: ", ";\n  display: grid;\n  height: 25px;\n  cursor: pointer;\n  :hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n  ", "\n  ", "\n"], ["\n  width: 100%;\n  grid-template-columns: ",
    ";\n  display: grid;\n  height: 25px;\n  cursor: pointer;\n  :hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n  ",
    "\n  ",
    "\n"])), function (_a) {
    var totalColumns = _a.totalColumns;
    return "repeat(" + totalColumns + ", 1fr)";
}, function (_a) {
    var isEven = _a.isEven;
    if (isEven) {
        return "background: " + CatizColors.deepBlue + ";";
    }
    else {
        return "background: " + CatizColors.blue + ";";
    }
}, function (_a) {
    var isSelected = _a.isSelected;
    if (isSelected) {
        return "background: rgba(255,255,255,0.6);";
    }
    return '';
});
var CenteredCell = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n  align-items: center;\n  height: 100%;\n"], ["\n  display: grid;\n  align-items: center;\n  height: 100%;\n"])));
var TableHeader = styled(Row)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", " !important;\n  background: rgba(50, 59, 85);\n  grid-template-columns: ", ";\n"], ["\n  color: ", ";\n  background-color: ",
    " !important;\n  background: rgba(50, 59, 85);\n  grid-template-columns: ",
    ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.tr.th.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.backgroundColor;
}, function (_a) {
    var totalColumns = _a.totalColumns;
    return "repeat(" + totalColumns + ", 1fr)";
});
var HeaderCell = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border: solid 1px gray;\n  text-align: left;\n"], ["\n  border: solid 1px gray;\n  text-align: left;\n"])));
var TableCell = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  text-transform: uppercase;\n  padding-left: 10px;\n  display: flex;\n  align-items: flex-start;\n"], ["\n  text-transform: uppercase;\n  padding-left: 10px;\n  display: flex;\n  align-items: flex-start;\n"])));
var RightBorderCell = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  border-left: solid 1px white;\n  width: 2px;\n  height: 100%;\n"], ["\n  border-left: solid 1px white;\n  width: 2px;\n  height: 100%;\n"])));
var CurrentItem = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 10px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  left: -2px;\n"], ["\n  width: 10px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  left: -2px;\n"])));
var TreeContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  height: 340px;\n  overflow-y: auto;\n  color: white;\n  border: solid 3px gray;\n"], ["\n  height: 340px;\n  overflow-y: auto;\n  color: white;\n  border: solid 3px gray;\n"])));
var InternalTopItem = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: 100%;\n  height: 50%;\n  border-bottom: solid 1px white;\n"], ["\n  width: 100%;\n  height: 50%;\n  border-bottom: solid 1px white;\n"])));
var InternalBottomItem = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  width: 100%;\n  height: 50%;\n  border-top: solid 1px white;\n"], ["\n  width: 100%;\n  height: 50%;\n  border-top: solid 1px white;\n"])));
var getTreeContent = function (stateFields, identifier, items) {
    if (stateFields[identifier]) {
        return stateFields[identifier];
    }
    return items || [];
};
export default function NewTreeWidget(props) {
    var attributes = props.attributes, column = props.column, item = props.item, restProps = __rest(props, ["attributes", "column", "item"]);
    var stateFromEnv = useContext(WindowStateContext);
    var _onTreeContainerClick = useContext(WindowEventContext)._onTreeContainerClick;
    var config = useContext(WindowConfigContext);
    var treeContent = getTreeContent(stateFromEnv.fields, restProps.identifier, item);
    var rows = flattenRoleArrForDisplay(treeContent.content, {});
    var handleTreeContainerClick = function () {
        console.log('clicked tree container');
        config.isBuilder && _onTreeContainerClick(props.identifier);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(RoleTable, { onClick: handleTreeContainerClick },
            React.createElement(TableHeader, __assign({ totalColumns: column.length }, restProps), column.map(function (col) {
                return col.attributes.icon ? (React.createElement(HeaderCell, null,
                    React.createElement("img", { height: 14, width: 14, src: require("../../assets/icons/" + col.attributes.icon.replace(/:/g, '') + ".png") }))) : (React.createElement(HeaderCell, null, col.attributes.text));
            })),
            React.createElement(TreeContainer, null, rows.map(function (row, index) {
                return (React.createElement(Row, { key: index, isEven: index % 2 === 0, isSelected: row.isSelected, totalColumns: column.length }, column.map(function (col, colIndex) {
                    return (React.createElement(React.Fragment, null, colIndex === 0 ? (React.createElement(TableCell, null,
                        React.createElement(LevelSpacer, { level: row.level, levelDict: row.levelDict, lastChild: row.lastChild }),
                        React.createElement(CenteredCell, null, row[col.attributes.text]))) : (React.createElement(TableCell, null, row[col.attributes.text]))));
                })));
            })))));
}
function LevelSpacer(_a) {
    var level = _a.level, levelDict = _a.levelDict, lastChild = _a.lastChild;
    return (React.createElement(React.Fragment, null,
        Array(level)
            .fill(1)
            .map(function (_, index) { return (React.createElement(RightBorderCell, { key: index, style: {
                marginRight: index === level - 1 ? '0px' : '18px',
                height: index === level - 1 && lastChild ? '55%' : '100%',
                borderLeftStyle: levelDict[index + 1] ? 'unset' : 'solid',
            } })); }),
        React.createElement(PresentItem, null)));
}
function PresentItem() {
    return (React.createElement(CurrentItem, null,
        React.createElement(InternalTopItem, null),
        React.createElement(InternalBottomItem, null)));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=index.js.map